export default function MainContent() {
    const codeStyle = {
        backgroundColor: "#eee",
        padding: "2px 6px",
        borderRadius: "4px",
        fontFamily: "monospace",
        fontSize: "0.95rem",
    };

    const codeBlockStyle = {
        display: "inline-block",
        backgroundColor: "#f0f0f0",
        padding: "4px 8px",
        borderRadius: "6px",
        fontFamily: "monospace",
        marginTop: "0.5rem",
        fontSize: "0.9rem",
        color: "#333",
    };

    return (
        <div
            style={{
                width: "100%",
                minHeight: "100vh",
                backgroundColor: "#f9f9f9",
                color: "#222",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: "2rem",
            }}
        >
            <div
                style={{
                    maxWidth: "700px",
                    backgroundColor: "#fff",
                    padding: "30px",
                    borderRadius: "12px",
                    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.1)",
                    textAlign: "center",
                }}
            >
                <h1 style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>
                    ✨ Welcome!
                </h1>
                <p
                    style={{
                        fontSize: "1.1rem",
                        color: "#555",
                        marginBottom: "2rem",
                    }}
                >
                    This is your main content area after the loader finishes.
                    Below are some helpful notes on how to customize the loader
                    component for your own project
                </p>

                <h2
                    style={{
                        fontSize: "1.5rem",
                        marginBottom: "1rem",
                        color: "#333",
                    }}
                >
                    🔧 Usage Instructions
                </h2>

                <ul
                    style={{
                        textAlign: "left",
                        paddingLeft: "1.2rem",
                        lineHeight: "1.8",
                        fontSize: "1rem",
                        color: "#444",
                    }}
                >
                    <li>
                        <strong>⏱ Set Loader Duration:</strong> Change the delay
                        inside the <code style={codeStyle}>useEffect</code> in{" "}
                        <code style={codeStyle}>App.jsx</code>:
                        <br />
                        <span style={codeBlockStyle}>
                            setTimeout(() =&gt; &#123; setLoading(false);
                            &#125;,{" "}
                            <span style={{ color: "#c0392b" }}>5000</span>);
                        </span>
                    </li>
                    <li>
                        <strong>📝 Custom Loader Text:</strong> Provide your own
                        text via <code style={codeStyle}>label1</code> and{" "}
                        <code style={codeStyle}>label2</code> props to{" "}
                        <code style={codeStyle}>&lt;Loader /&gt;</code>.
                    </li>
                    <li>
                        <strong>🖼 Custom Logo:</strong> Pass your image path
                        using <code style={codeStyle}>logoSrc</code> to replace
                        the default logo.
                    </li>
                    <li>
                        <strong>🎨 Styling:</strong> Update{" "}
                        <code style={codeStyle}>Loader.css</code> to match your
                        brand’s light/dark theme.
                    </li>
                    <li>
                        <strong>📦 Reusability:</strong> You can extract the
                        loader into its own npm package or share via GitHub for
                        other devs to use.
                    </li>
                </ul>

                <p
                    style={{
                        marginTop: "2rem",
                        color: "#777",
                        fontSize: "0.95rem",
                    }}
                >
                    💡 Tip: Keep your loaders lightweight and don’t delay the
                    user too long!
                </p>

                <div class="madeBy">
                    Made by
                    <a
                        href="https://bilalabdulhadi.com"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Bilal Abdulhadi
                    </a>{" "}
                    •
                    <a
                        href="https://github.com/bilalabdulhadii"
                        target="_blank"
                        rel="noreferrer"
                    >
                        GitHub
                    </a>{" "}
                    •
                    <a
                        href="https://www.linkedin.com/in/bilalabdulhadii"
                        target="_blank"
                        rel="noreferrer"
                    >
                        LinkedIn
                    </a>
                </div>
            </div>
        </div>
    );
}
